import type { HeaderNavLink } from './header';

export const headerData: HeaderNavLink[] = [
  {
    linkUrl: '#',
    linkLabel: 'Get My License',
    isDropDown: true,
    menuSize: '340px',
    ddList: [
      {
        linkUrl: '/pre-license/arizona/',
        linkLabel: '<strong>Arizona</strong> Insurance License',
        newTab: false,
        nofollow: false,
      },
      {
        linkUrl: '/pre-license/california/',
        linkLabel: '<strong>California</strong> Insurance License',
        newTab: false,
        nofollow: false,
      },
      {
        linkUrl: '/pre-license/florida/',
        linkLabel: '<strong>Florida</strong> Insurance License',
        newTab: false,
        nofollow: false,
      },
      {
        linkUrl: '/pre-license/georgia/',
        linkLabel: '<strong>Georgia</strong> Insurance License',
        newTab: false,
        nofollow: false,
      },
      {
        linkUrl: '/pre-license/illinois/',
        linkLabel: '<strong>Illinois</strong> Insurance License',
        newTab: false,
        nofollow: false,
      },
      {
        linkUrl: '/pre-license/massachusetts/',
        linkLabel: '<strong>Massachusetts</strong> Insurance License',
        newTab: false,
        nofollow: false,
      },
      {
        linkUrl: '/pre-license/michigan/',
        linkLabel: '<strong>Michigan</strong> Insurance License',
        newTab: false,
        nofollow: false,
      },
      {
        linkUrl: '/pre-license/missouri/',
        linkLabel: '<strong>Missouri</strong> Insurance License',
        newTab: false,
        nofollow: false,
      },
      {
        linkUrl: '/pre-license/north-carolina/',
        linkLabel: '<strong>North Carolina</strong> Insurance License',
        newTab: false,
        nofollow: false,
      },
      {
        linkUrl: '/pre-license/ohio/',
        linkLabel: '<strong>Ohio</strong> Insurance License',
        newTab: false,
        nofollow: false,
      },
      {
        linkUrl: '/pre-license/oklahoma/',
        linkLabel: '<strong>Oklahoma</strong> Insurance License',
        newTab: false,
        nofollow: false,
      },
      {
        linkUrl: '/pre-license/pennsylvania/',
        linkLabel: '<strong>Pennsylvania</strong> Insurance License',
        newTab: false,
        nofollow: false,
      },
      {
        linkUrl: '/pre-license/south-carolina/',
        linkLabel: '<strong>South Carolina</strong> Insurance License',
        newTab: false,
        nofollow: false,
      },
      {
        linkUrl: '/pre-license/tennessee/',
        linkLabel: '<strong>Tennessee</strong> Insurance License',
        newTab: false,
        nofollow: false,
      },
      {
        linkUrl: '/pre-license/texas/',
        linkLabel: '<strong>Texas</strong> Insurance License',
        newTab: false,
        nofollow: false,
      },
      {
        linkUrl: '/pre-license/washington/',
        linkLabel: '<strong>Washington</strong> Insurance License',
        newTab: false,
        nofollow: false,
      },
    ],
  },
  {
    linkUrl: '#',
    linkLabel: 'Continuing Ed',
    menuSize: '340px',
    isDropDown: true,
    ddList: [
      {
        linkUrl: '/continuing-education/california/',
        linkLabel: '<strong>California</strong> Continuing Education',
        newTab: false,
        nofollow: false,
      },
      {
        linkUrl: '/continuing-education/georgia/',
        linkLabel: '<strong>Georgia</strong> Continuing Education',
        newTab: false,
        nofollow: false,
      },
      {
        linkUrl: '/continuing-education/illinois/',
        linkLabel: '<strong>Illinois</strong> Continuing Education',
        newTab: false,
        nofollow: false,
      },
      {
        linkUrl: '/continuing-education/ohio/',
        linkLabel: '<strong>Ohio</strong> Continuing Education',
        newTab: false,
        nofollow: false,
      },
      {
        linkUrl: '/continuing-education/tennessee/',
        linkLabel: '<strong>Tennessee</strong> Continuing Education',
        newTab: false,
        nofollow: false,
      },
      {
        linkUrl: '/continuing-education/texas/',
        linkLabel: '<strong>Texas</strong> Continuing Education',
        newTab: false,
        nofollow: false,
      },
      {
        linkUrl: '/continuing-education/submit-exam/',
        linkLabel: '<strong>Submit</strong> CE Exam',
        newTab: false,
        nofollow: false,
      },
    ],
  },
  {
    linkUrl: '/about-us/',
    linkLabel: 'About Us',
    menuSize: '340px',
    isDropDown: false,
  },
  {
    linkUrl: '#',
    linkLabel: 'Resources',
    menuSize: '340px',
    isDropDown: true,
    ddList: [
      {
        linkUrl: '/resources/',
        linkLabel: '<strong>Blog</strong>',
        newTab: false,
        nofollow: false,
      },
      {
        linkUrl: '/aceable-insurance-app/',
        linkLabel: '<strong>Aceable Insurance App</strong>',
        newTab: false,
        nofollow: false,
      },
      {
        linkUrl: '/question-of-the-day/',
        linkLabel: '<strong>Question of the Day</strong>',
        newTab: false,
        nofollow: false,
      },
    ],
  },
];

export const myAccountData: HeaderNavLink[] = [
  {
    linkUrl: '#',
    linkLabel: 'My Account',
    menuSize: '180px',
    isDropDown: true,
    ddList: [
      {
        linkUrl: 'https://app.aceable.com/user/signin?v=INS',
        linkLabel: 'Sign In',
        newTab: false,
        nofollow: false,
      },
      {
        linkUrl: '/support/',
        linkLabel: 'Help Center',
        newTab: false,
        nofollow: false,
      },
    ],
  },
];

export const loggedInMyAccountData: HeaderNavLink[] = [
  {
    linkUrl: '#',
    linkLabel: 'My Account',
    menuSize: '180px',
    isDropDown: true,
    ddList: [
      {
        linkUrl: 'https://app.aceable.com/user/signin?v=INS',
        linkLabel: 'My Dashboard',
        newTab: false,
        nofollow: false,
      },
      {
        linkUrl: '/support/',
        linkLabel: 'Help Center',
        newTab: false,
        nofollow: false,
      },
    ],
  },
];
